import { FieldType, FieldTypeContext } from '../../setting/contact/properties/properties.const';

export class ReportCustomConst {
  static displayColumns = () => {
    return [
      {
        title: 'STT',
        key: 'index',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Tên Báo Cáo',
        key: 'name',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Dạng Báo Cáo',
        key: 'report_type',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Thời Gian Thiết Lập',
        key: 'created_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
      {
        title: 'Người Thiết Lập',
        key: 'created_by',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  };
  static FieldTypeArray = () => {
    return [
      { id: FieldType.Text.toString(), text: FieldTypeContext.Text },
      { id: FieldType.Textarea.toString(), text: FieldTypeContext.Textarea },
      { id: FieldType.Number.toString(), text: FieldTypeContext.Number },
      { id: FieldType.Date.toString(), text: FieldTypeContext.Date },
      { id: FieldType.Select.toString(), text: FieldTypeContext.Select },
      {
        id: FieldType.MultiSelect.toString(),
        text: FieldTypeContext.MultiSelect,
      },
    ];
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/custom/custom.const.ts